import { Button } from '@cfa/react-core';
import { FC } from 'react';
import { themeColors, themeSizes } from '../../../../styles/globalStyleVars';
import { TypographyStyled } from '../../../Styled/Typography';

interface ItemProps {
  button: string;
  description: string;
  handleClick: () => void;
  icon: React.JSX.Element;
  title: string;
}

const MobileItem: FC<ItemProps> = ({
  button,
  description,
  handleClick,
  icon,
  title,
}) => {
  return (
    <div style={{ display: 'flex', alignItems: 'flex-start', width: '100%' }}>
      <div style={{ flexShrink: 0 }}>{icon as React.ReactNode}</div>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          flex: '1 1 0',
          minWidth: 0,
          marginLeft: themeSizes.md,
          textAlign: 'left',
        }}
      >
        <div>
          {
            <TypographyStyled
              text={title}
              fontWeight='bold'
              color={themeColors.colorGray_7}
              variant='body2'
            />
          }
        </div>
        <div style={{ marginTop: themeSizes.xs }}>
          <TypographyStyled
            text={description}
            color={themeColors.colorGray_7}
            variant='body2'
          />
        </div>
        <div style={{ marginTop: themeSizes.sm, width: '100%' }}>
          {
            <Button
              onPress={handleClick}
              size='sm'
              style={{ minWidth: '100%' }}
              variant='outlined'
            >
              {button}
            </Button>
          }
        </div>
      </div>
    </div>
  );
};

export default MobileItem;
